import FeaturedVenues from '@components/featuredVenues/FeaturedVenues'
import Page from '@components/Page/Page'
import { Venue } from '@components/venue/Venue'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { FeaturedVenue as FeaturedVenueModel } from '@models/FeaturedVenue'
import {
  getFeaturedVenues,
  selectFeaturedVenues,
  setFeaturedVenuesQuery,
} from '@store/FeaturedVenuesReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { Col, TableColumnsType } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const FeaturedVenuePage = () => {
  const dispatch = useAppDispatch()
  const featuredVenues = useAppSelector(selectFeaturedVenues())
  const { isOpen } = useSBRM()
  const { query, isLoading } = useAppSelector((state) => state.featuredVenues)

  const columns: TableColumnsType<FeaturedVenueModel> = [
    {
      title: 'Statut',
      width: '15%',
      render: (record: FeaturedVenueModel) => (
        <FeaturedVenues.Tag id={record.id} />
      ),
    },
    {
      title: 'Venues',
      render: (record: FeaturedVenueModel) =>
        record.venues.length > 1 ? (
          <Venue.AvatarGroup ids={record.venues} size={40} maxCount={10} />
        ) : (
          record.venues.map((id) => <Venue.Avatar id={id} />)
        ),
    },
    {
      title: 'Dates',
      align: 'right',
      render: (record: FeaturedVenueModel) => (
        <FeaturedVenues.Date model={record} />
      ),
    },
    {
      title: 'Action Button',
      align: 'right',
      width: '10%',
      render: (record: FeaturedVenueModel) => {
        const isPast = dayjs(record.endDate).isBefore(dayjs(), 'day')

        const actions = isPast
          ? [SBRMAction.Delete]
          : [SBRMAction.Update, SBRMAction.Delete]

        return (
          <SBRM.Actions
            actions={actions}
            entity={Entity.featuredVenue}
            entityId={record.id}
          />
        )
      },
    },
  ]

  const fetchFeaturedVenues = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      columnKey: params.sort.columnKey ?? 'start_date',
      order: params.sort.order ?? 'descend',
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }
    dispatch(setFeaturedVenuesQuery(newQuery))
    dispatch(getFeaturedVenues(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<FeaturedVenueModel>({
    onParamsChange: fetchFeaturedVenues,
  })

  useEffect(() => {
    if (isOpen) return

    fetchFeaturedVenues(params)
  }, [isOpen])

  return (
    <Page permissions={Permission.listFeaturedVenue} noWrapWithCol>
      <Col span={24}>
        <FeaturedVenues.Live />
      </Col>
      <PageTitle
        level={4}
        title="Featured venue"
        toolbar={
          <SBRM.Actions
            actions={[SBRMAction.Create]}
            entity={Entity.featuredVenue}
          />
        }
      />
      <Col span={24}>
        <SBTable
          showHeader={false}
          columns={columns}
          dataSource={featuredVenues}
          loading={isLoading}
          onChange={handleTableChange}
          pagination={query.pagination}
        />
      </Col>
    </Page>
  )
}
export default FeaturedVenuePage
